// Vendors
import styled from 'styled-components';

const UploadIdDifferentDataViewStyled = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};
`;
UploadIdDifferentDataViewStyled.displayName = 'UploadIdDifferentDataViewStyled';

const UploadIdDifferentDataViewInformationStyled = styled(UploadIdDifferentDataViewStyled)`
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing_200};
`;
UploadIdDifferentDataViewInformationStyled.displayName =
  'UploadIdDifferentDataViewInformationStyled';

const UploadIdLandingListComponentStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_250};
  margin: 0;
  list-style: none;
  padding: 0;
`;
UploadIdLandingListComponentStyled.displayName = 'UploadIdLandingListComponentStyled';

const UploadIdLandingListItemComponentStyled = styled.li`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing_250};
  margin: 0;
  padding: 0;
`;
UploadIdLandingListItemComponentStyled.displayName = 'UploadIdLandingListItemComponentStyled';

export {
  UploadIdDifferentDataViewStyled,
  UploadIdDifferentDataViewInformationStyled,
  UploadIdLandingListComponentStyled,
  UploadIdLandingListItemComponentStyled,
};
